import "./index.less";
const CLASS_NAME = "directive-fold";
const env = import.meta.env;
const debug = false;
/**
 * 使用方法 -> 指定结构
<div v-fold>
  <span class="text"> 文字 </span>
</div>
 */

export const vFold = {
  mounted(el: any) {
    if (debug) console.groupCollapsed("文字折叠", el);
    const maxHeight = 22;

    const span = el.getElementsByClassName("text")[0];
    const height = span.offsetHeight;
    if (height > maxHeight) addFold(el);
    if (debug) console.log(maxHeight, height);
    if (debug) console.groupEnd();
  },
};

/**
 * 添加折叠元素
 */
const addFold = (el: any) => {
  if (debug) console.groupCollapsed("添加折叠文字", el);
  const className = addClass(el, CLASS_NAME);

  const div = document.createElement("span");
  div.className = "btn";
  div.onclick = () => (el.className = el.className == className ? `${className} unFold` : className);
  div.innerHTML = `<span class='btnFold'>展开 ∨</span><span class='btnUnFold'>收起 ∧</span>`;

  el.append(div);
  if (debug) console.groupEnd();
};
/**
 * 添加class
 */
export const addClass = (el: any, className: string) => {
  let newClass = el.className.split(" ").filter((n: string) => n);
  newClass.push(className);
  el.className = newClass.join(" ");
  return el.className;
};
